<template>
    <div class="col-12 d-xxl-none p-0 row">
        <div id="announcements" class="carousel slide rounded mb-3" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button v-for="(item, itemIndex) in carouselItems" type="button" data-bs-target="#announcements" :data-bs-slide-to="itemIndex" :aria-label="'Slide '+itemIndex+1"></button>
            </div>

            <div class="carousel-inner rounded">
                <a v-for="(item, itemIndex) in carouselItems" :class="'carousel-item'+(itemIndex === 0 ? 'active' : '')" :href="item.href">
                    <img class="d-block w-100" :src="item.imgSrc" :alt="item.imgAlt">
                    <div class="carousel-caption">
                        <h6 v-text="item.title"></h6>
                        <p v-text="item.description"></p>
                    </div>
                </a>
            </div>

            <button class="carousel-control-prev" type="button" data-bs-target="#announcements" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>

            <button class="carousel-control-next" type="button" data-bs-target="#announcements" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NewsCarousel',
    data() {
        return {
            carouselItems: [
                {
                    className: "carousel-item active",
                    href: "/gallery/ja_m1l",
                    imgSrc: "https://i0.wp.com/essential-japan.com/wp-content/uploads/2025/06/Pokemon-Mega-Evolutions-Boosters-2.webp?resize=1024%2C577&ssl=1",
                    imgAlt: "Mega sets japanese banner",
                    title: "MEGA BRAVE / MEGA SYMPHONIA",
                    description: "Coming August 1st"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/csm1a",
                    imgSrc: "https://i.ytimg.com/vi/AtSPAFMF7b0/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLDqwigJjK7TY5j7kvnQqFN6uA4Nfw",
                    imgAlt: "Eevee grove",
                    title: "EEVEE GROVE",
                    description: "Coming June 26th"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/csm1a",
                    imgSrc: "https://dipocaco.me/assets/dipocaco/sets/csm1a/banner.png",
                    imgAlt: "Chinese Sets",
                    title: "NEW LANGUAGE",
                    description: "First chinese sets are now available!"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/ja_sv11b",
                    imgSrc: "https://dipocaco.me/assets/dipocaco/sets/ja_sv11b/banner.webp",
                    imgAlt: "Black Bolt & White Flare",
                    title: "Black Bolt & White Flare",
                    description: "Coming 06/06!"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/tcgpa3",
                    imgSrc: "https://static0.gamerantimages.com/wordpress/wp-content/uploads/2025/04/pokemon-tcg-pocket-celestial-guardians-release-date.jpg",
                    imgAlt: "Celestial Guardians",
                    title: "Celestial Guardians",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/ja_sv10",
                    imgSrc: "https://www.pokemon-card.com/ex/sv10/assets/images/hero-visual.jpg",
                    imgAlt: "Glory of Team Rocket",
                    title: "Glory of Team Rocket",
                    description: "TEAM ROCKET IS BACK"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/sv9",
                    imgSrc: "/assets/dipocaco/sets/sv9/banner.webp",
                    imgAlt: "Journey Together",
                    title: "Journey Together",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/tcgpa2b",
                    imgSrc: "https://pbs.twimg.com/media/GmkR-LZWoAADBBV.jpg:large",
                    imgAlt: "Shiny Revelry",
                    title: "Shiny Revelry",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/sv10",
                    imgSrc: "https://static1.srcdn.com/wordpress/wp-content/uploads/2025/03/destined-rivals-info-hed.jpg",
                    imgAlt: "Destined Rivals",
                    title: "Destined Rivals",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/tcgpa2a",
                    imgSrc: "https://www.pokemon.com/static-assets/content-assets/cms2/img/video-games/_tiles/tcg-pocket/2025/02/27/pokemon-tcg-pocket-169-en.png",
                    imgAlt: "Triumphant Light",
                    title: "Triumphant Light",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/ja_sv9a",
                    imgSrc: "https://www.pokemon-card.com/products/2025/images/sv9a_banner.jpg",
                    imgAlt: "Hot Wind Arena",
                    title: "Hot Wind Arena",
                    description: "OUT NOW"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/ja_sv9",
                    imgSrc: "https://silvermine.app/cdn/shop/files/banner_sv9.png?v=1664742598607156256",
                    imgAlt: "Battle Partners",
                    title: "Japanese set Battle Partners is now in shop!",
                    description: "More japanese sets coming soon!"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/ja_sv8a",
                    imgSrc: "https://megacards.co.uk/cdn/shop/collections/Terastal-Festival.jpg?v=1733986681",
                    imgAlt: "Terestal festival ex",
                    title: "Terestal festival ex",
                    description: "Now in japanese!"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/tcgpa2",
                    imgSrc: "https://www.dexerto.com/cdn-image/wp-content/uploads/2025/01/27/Pokemon-TCG-Pocket-Space-Time-Smackdown.jpg",
                    imgAlt: "Space-Time Smackdown",
                    title: "Space-Time Smackdown now available!",
                    description: "Pokemon TCG Pocket’s highly anticipated new expansion, Space-Time Smackdown is finally here."
                },
                {
                    className: "carousel-item",
                    href: "/gallery/sv8",
                    imgSrc: "/assets/dipocaco/sets/sv8/promo/banner.webp",
                    imgAlt: "Surging Sparks",
                    title: "Check out Surging Sparks now!",
                    description: "Seize the day with stunning illustration rare and special illustration rare cards."
                },
                {
                    className: "carousel-item",
                    href: "/gallery/tcgp1a",
                    imgSrc: "/assets/dipocaco/sets/tcgp1a/promo/banner.webp",
                    imgAlt: "Mythical Island",
                    title: "Mythical Island is available now!",
                    description: "Mythical Island expansion brings lots of beautiful new cards to your next booster pack!"
                },
                {
                    className: "carousel-item",
                    href: "/gallery/sv8pt5",
                    imgSrc: "/assets/dipocaco/sets/sv8pt5/promo/banner_voo.webp",
                    imgAlt: "Prismatic Evolutions",
                    title: "Prismatic Evolutions is just around the corner!",
                    description: "Show your love for the eeveelutions in this new set, coming early 2025!"
                }
            ]
        }
    }
}
</script>
<style language="scss" scoped>

.carousel-caption {
    * {
        color: white;
    }

    padding: .5em;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.5);
}

</style>